import { connect } from 'react-redux';
import { SecretField } from 'components/common';
import { Box, BoxEmpty } from 'components/common/box';
import { FormGroup } from 'components/common/form';

const GroupIntegrations = connect(state => ({
  messages: state.messages,
  pageState: state.pageState,
  serverConfig: state.serverConfig
}))(({
  messages,
  pageState: { group },
  serverConfig
}) => (
  <div className="integrations">
    <Box title={messages.settingsIntegrations}>
      {serverConfig.showGroupHash ? (
        <div>
          <FormGroup
            label={messages.groupsHash}
          >
            <SecretField
              value={group.hash}
            />
          </FormGroup>
        </div>
      ) : (
        <BoxEmpty
          padding={0}
          text={messages.settingsIntegrationsNone}
        />
      )}
    </Box>
  </div>
));

export default GroupIntegrations;
